import React from 'react';
import { HeaderTemplate } from 'themes/components';
import { inject } from 'mobx-react';

@inject(i => ({
	currentView: i.rootStore.viewStore,
	rootStore: i.rootStore,
}))
class Header extends React.Component {
	constructor(props) {
		super(props);
		const mainView = this.props.rootStore.viewStore;
		// Clear header component
		mainView.headerSetSearch();
		mainView.headerSetButton();
		mainView.headerSetComponent();
	}
	render() {
		return <HeaderTemplate {...this.props} />;
	}
}

export default Header;
